"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSubscriptionOverviewMutator = exports.useSubscriptionOverviewState = exports.ShopPageSubscriptionsDisplayProvider = void 0;
const react_1 = __importStar(require("react"));
const constants_1 = require("../../subscription-overview/utils/constants");
const SubscriptionOverviewStateContext = react_1.default.createContext(null);
const SubscriptionOverviewDispatchContext = react_1.default.createContext(null);
const SubscriptionOverviewReducer = (state, action) => {
    switch (action.type) {
        case constants_1.SUBSCRIPTION_ACTION.SET_SUBSCRIPTION: {
            const { subscription } = action.payload;
            return Object.assign(Object.assign({}, state), { subscription });
        }
        default: {
            throw new Error(`[SubscriptionOverviewReducer] Unsupported action type: ${action.type}.`);
        }
    }
};
const ShopPageSubscriptionsDisplayProvider = (props) => {
    const { orderContext, subscriptionContext, hasSubscription, children } = props;
    const [state, dispatch] = (0, react_1.useReducer)(SubscriptionOverviewReducer, {
        orderContext,
        subscriptionContext,
        hasSubscription
    });
    return (react_1.default.createElement(SubscriptionOverviewStateContext.Provider, { value: state },
        react_1.default.createElement(SubscriptionOverviewDispatchContext.Provider, { value: dispatch }, children)));
};
exports.ShopPageSubscriptionsDisplayProvider = ShopPageSubscriptionsDisplayProvider;
const useSubscriptionOverviewState = () => {
    const context = (0, react_1.useContext)(SubscriptionOverviewStateContext);
    if (context === undefined) {
        throw new Error("useSubscriptionOverviewState must be used within a SubscriptionOverviewProvider.");
    }
    return context;
};
exports.useSubscriptionOverviewState = useSubscriptionOverviewState;
const useSubscriptionOverviewMutator = () => {
    const dispatch = (0, react_1.useContext)(SubscriptionOverviewDispatchContext);
    if (!dispatch) {
        throw new Error("useSubscriptionOverviewMutator must be used within a SubscriptionOverviewProvider");
    }
    const setSubscription = (subscription) => {
        dispatch({ type: constants_1.SUBSCRIPTION_ACTION.SET_SUBSCRIPTION, payload: { subscription } });
    };
    return { setSubscription };
};
exports.useSubscriptionOverviewMutator = useSubscriptionOverviewMutator;
